<template>
    <div v-if="this.data.completeOrder">
        <section class="bg-white py-12">
            <div class="px-12 container">
                <h1 class="text-blue text-3xl text-center">Thank You, and Next Steps</h1>
            </div>
            <hr class="border-green w-8 mx-auto" />

            <order-invoice :order-invoice="data.completeOrder.invoice" :payment-method="data.completeOrder.paymentmethod" class="container px-12 py-4" />
        </section>

        <section class="bg-grey-100 py-16">
            <div class="px-12 container -mt-12">
                <div class="flex flex-col md:flex-row mt-12" v-for="service in filteredServices" :key="service.id">
                    <div class="md:pr-4">
                        <i class="text-6xl" :class="icons[service.type]" aria-hidden="true"></i>
                    </div>
                    <div class="flex-1 md:px-4">
                        <h4>{{ service.title }}</h4>
                        <p class="mb-0">Check the status of your new service from the Services page. Once it has been activated, you can also find your access details and manage your service from the same area.</p>
                    </div>
                    <div class="align-self-center md:pl-4">
                        <a :href="service.href" class="btn btn-success" target="_blank">View My Service</a>
                    </div>
                </div>

                <div v-if="data.completeOrder.domains.length" class="flex flex-col md:flex-row mt-12">
                    <div class="md:pr-4">
                        <i class="text-6xl fal fa-globe" aria-hidden="true"></i>
                    </div>
                    <div class="flex-1 md:px-4">
                        <h4>Domain Names</h4>
                        <p class="mb-0">Check the status of your domains from the Services page. You can also view and manage your domain names from the same area.</p>
                    </div>
                    <div class="align-self-center md:pl-4">
                        <a href="/services/domains" class="btn btn-success" target="_blank">View My Domains</a>
                    </div>
                </div>
            </div>
        </section>

        <div v-if="data.completeOrder.paymentmethod === 'bpay'" class="bg-white py-16">
            <article class="px-12 container">
                <section class="mb-12">
                    <h3>Paying by BPAY</h3>
                    <p>
                        This invoice will remain
                        <span class="sau-font-bold">“Unpaid”</span> as your transaction will be finalised once payment has been processed via your bank or financial institution.
                    </p>
                    <p>BPAY payments can take up to 3 business days to process. If you need to pay for your transaction urgently, please choose the Credit Card or PayPal options.</p>
                </section>
                <section>
                    <h3>What happens after your BPAY payment?</h3>
                    <p>BPAY payments can take 2-3 business days to be processed. Your transaction won’t be complete until we receive full payment.</p>
                    <p>If the exact payment matches an invoice, our automated systems will apply payment to the invoice that matches that invoice amount.</p>
                    <p>Otherwise Servers Australia will apply an “Account Credit” onto your account. You will then need to login to your Servers Australia account and pay the invoice using the “Account Credit” payment method.</p>
                </section>
            </article>
        </div>
    </div>
</template>

<script>
import Invoice from "./Invoice";

export default {
    props: {
        data: Object,
        order: Object
    },

    components: {
        "order-invoice": Invoice
    },

    activated() {
        if (!this.data.completeOrder) {
            return this.$router.push("/order");
        } else {
            const transactionData = {
                'event': "mysau-completed-order",
                'ecommerce': {
                    'purchase': {
                        'actionField': {
                            'id': this.data.completeOrder.order.data.orderid,
                            'revenue': this.invoice.total, // Total transaction value (incl. tax and shipping)
                            'tax': this.invoice.tax,
                            'shipping': 0
                        },
                        'products': this.invoice.items.map(invoiceItem => {
                            return {
                                'id': invoiceItem.id,
                                'name': invoiceItem.description,
                                'category': this.filteredServices.find(service => service.id === invoiceItem.relid).type,
                                'price': invoiceItem.amount,
                                'quantity': 1
                            };
                        })
                    }
                }
            };

            dataLayer.push(transactionData);
        }
    },

    computed: {
        invoice() {
            return this.data.completeOrder.invoice;
        },

        completeOrder() {
            return this.data.completeOrder.order;
        },

        filteredServices() {
            return this.data.completeOrder.services.map(service => {
                return {
                    ...service,
                    ...{
                        href: `/service/${service.type}/${service.id}/summary`
                    }
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    max-width: 800px;
}
</style>
